import { Component } from 'react';
import {
    analyze,
    getContentAnalyzeStatus,
    getList,
    getMonthlyCategoriesContentAnalysis,
    getMonthlyPagesContentAnalysis,
} from './query';
import Markdown from 'react-markdown';
import moment from 'moment';
import Loading from '../../components/Loading';
import { isTrue } from '../../helpers/isTrue';
import AnalyzeContentDateModal from '../../components/Modals/AnalyzeContentDateModal';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import Pagination from './Pagination';
import { withTranslation } from 'react-i18next';

class AnalyzeContent extends Component {
    constructor(props) {
        super();
        this.onAnalyze = this.onAnalyze.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onOpenConfirmationModal = this.onOpenConfirmationModal.bind(this);
        this.onCloseConfirmationModal = this.onCloseConfirmationModal.bind(this);
        this.checkPages = this.checkPages.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onToggleActiveTab = this.onToggleActiveTab.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.getData = this.getData.bind(this);
        this.onToggleBox = this.onToggleBox.bind(this);

        const reportNameFromUrl = window.location.href?.split('/')?.slice(5)?.join('/');
        this.report_name = props.report_name ?? reportNameFromUrl;
        this.checkIsInProgress = this.checkIsInProgress.bind(this);
        this.getItems = this.getItems.bind(this);

        this.state = {
            data: [],
            firstFive: [],
            isInProgress: true,
            loading: true,
            total_number_of_available: 0,
            active_ai_count: 0,
            remaining_count: 0,
            isOpen: false,
            isOpenConfirmationModal: false,
            activeTab: null,
            pagination: { page: 0, size: 5 },
            showanalysis: true,
        };
    }

    async componentDidMount() {
        try {
            this.getItems();
            this.checkIsInProgress();
        } catch (err) {
            console.log(err);
        }
    }

    onToggleActiveTab(id) {
        let value = id;
        if (id === this.state.activeTab) value = null;
        this.setState({
            activeTab: value,
        });
    }

    onToggleBox() {
        this.setState({
            showanalysis: !this.state.showanalysis,
        });
    }

    onOpenModal() {
        this.setState({
            isOpen: true,
        });
    }
    onCloseModal() {
        this.setState({
            isOpen: false,
        });
    }

    onOpenConfirmationModal() {
        this.setState({
            isOpenConfirmationModal: true,
        });
    }
    onCloseConfirmationModal() {
        this.setState({
            isOpenConfirmationModal: false,
        });
    }

    onChangePage(item) {
        this.setState({
            pagination: {
                ...this.state.pagination,
                page: item,
            },
        });
    }

    async checkPages({ start_date, end_date }) {
        try {
            const dates = {
                start_date: moment(start_date).format('YYYY-MM-DD'),
                end_date: moment(end_date).format('YYYY-MM-DD'),
            };

            const data = {
                domain: window.filters.get().domain.value,
                dates,
            };

            if (this.props.category) data.category = this.props.category;

            const reportQuery =
                this.report_name === 'pages'
                    ? getMonthlyPagesContentAnalysis(data)
                    : getMonthlyCategoriesContentAnalysis(data);
            const report = await reportQuery.update();

            return report;
        } catch (err) {
            console.log(err);
            return [];
        }
    }

    async onSubmit({ start_date, end_date }) {
        const existingCount = await this.checkPages({
            start_date,
            end_date,
        });
        if (existingCount?.length > 20) {
            this.onAnalyze({ start_date, end_date });
        } else {
            this.onOpenConfirmationModal();
            this.setState({
                start_date,
                end_date,
            });
        }
        this.onCloseModal();
    }

    async onAnalyze({ start_date, end_date }) {
        try {
            this.setState({
                isInProgress: true,
            });

            const data = {
                domain_uuid: this.props.domain_id,
                belongs_to: this.report_name,
                start_date: moment(start_date).format('YYYY-MM-DD'),
                end_date: moment(end_date).format('YYYY-MM-DD'),
            };

            if (this.props.category) data.category = this.props.category;

            await analyze(this.props.csrf_token, data);

            this.getItems();
            this.checkIsInProgress();
        } catch (err) {
            this.setState({
                isInProgress: false,
            });
            console.log(err);
        }
    }

    isActive(results) {
        if (!results || results?.length === 0) return false;
        let lastPublished = results[0]?.updated_at;
        for (let i = 1; i < results.length; i++) {
            if (new Date(results[i].updated_at) > new Date(lastPublished)) {
                lastPublished = results[i].updated_at;
            }
        }
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return new Date(lastPublished) > new Date(yesterday);
    }

    async getItems() {
        try {
            this.setState({
                loading: true,
            });
            const data = !this.props.all ? { belongs_to: this.report_name } : {};
            const list = await getList(this.props.csrf_token, this.props.domain_id, data);
            const listData = await list.json();

            this.isActive(listData?.results);

            this.setState({
                data: listData?.results ?? [],
                total_number_of_available: listData?.total_number_of_available,
                active_ai_count: listData?.active_ai_count,
                remaining_count: listData?.remaining_count,
                loading: false,
                isInProgress: this.isActive(listData?.results),
            });
        } catch (err) {
            this.setState({
                loading: false,
            });
            console.log(err);
        }
    }

    async checkIsInProgress() {
        try {
            const res = await getContentAnalyzeStatus(
                this.props.csrf_token,
                this.props.domain_id,
                this.report_name,
            );
            const data = await res.json();
            if (data.is_in_progress === true) {
                this.setState({
                    isInProgress: true,
                });
                setTimeout(() => this.checkIsInProgress(), 6000);
            } else {
                this.getItems();
            }
        } catch (err) {
            console.log(err);
        }
    }

    onClickOnStep(e) {
        const items = document.querySelectorAll('.analyze-collapsed');

        for (let item of items) {
            if (item.id === e.target.id) {
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                } else {
                    item.classList.add('active');
                }
            } else {
                item.classList.remove('active');
            }
        }
    }

    showTitle(item) {
        const { t } = this.props;
        const secondPart =
            item?.start_date && item?.start_date !== 'None' ? (
                <div className="content-analysis-dates">
                    {moment(item.start_date).format('DD MMM YYYY')}{' '}
                    <span className="analyze-arrow">-</span>{' '}
                    {moment(item.end_date).format('DD MMM YYYY')}
                </div>
            ) : (
                <div className="content-analysis-dates">
                    {moment(item.updated_at).format('DD MMM YYYY')}
                </div>
            );

        let firstPart = '';
        if (item.page === 'pages') {
            firstPart = t('content_analyze.top_pages');
            // firstPart = 'Top Pages Analysis';
        } else if (item.page.includes('categories')) {
            const title = item.page.split(':in=')?.[1];
            firstPart = `[${decodeURIComponent(title)}] ${t('content_analyze.analysis')}`;
        } else {
            firstPart = `${t('content_analyze.analysis')}:`;
        }

        return (
            <>
                <div className="content-analysis-title">{firstPart}</div> {secondPart}
            </>
        );
    }

    getData(data) {
        const showedValue = data.slice(
            this.state.pagination.page * this.state.pagination.size,
            (this.state.pagination.page + 1) * this.state.pagination.size,
        );
        return showedValue;
    }

    render() {
        const { t } = this.props;
        const data = this.state.data;
        const showAll = !window.location.href.includes('/opportunities/recommendations/');

        const showedValue = this.getData(data);

        return (
            <>
                <div className="card table-main rounded-main overflow-hidden mb-10">
                    <div className="content-analysis">
                        <div className="content-analysis-header">
                            <div className="content-analysis-header-left">
                                <div className="content-analysis-header-img">
                                    <img src="/static/img/analysis.svg" loading="lazy" alt="img" />
                                </div>
                                <div className="content-analysis-header-left-header">
                                    <div className="hasAttachement feature_beta">
                                        {t('content_analyze.header')}
                                    </div>
                                    <div className="content-analysis-header-left-subheader">
                                        <span>
                                            {t('content_analyze.subtitle.availabe', {
                                                number: this.state.remaining_count,
                                            })}
                                        </span>{' '}
                                        {t('content_analyze.subtitle.text', {
                                            number: this.state.total_number_of_available,
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="content-analysis-header-right">
                                <button
                                    className="button button-filled button-primary"
                                    onClick={this.onOpenModal}
                                    id="analyze-content-btn"
                                    disabled={
                                        !isTrue(this.props.is_superuser) &&
                                        (this.state.isInProgress ||
                                            this.state.remaining_count === 0)
                                    }
                                >
                                    {t('content_analyze.btn_name')}
                                </button>
                                <button
                                    className="content-analysis-header-right-action-btn"
                                    onClick={this.onToggleBox}
                                >
                                    <i
                                        className={
                                            this.state.showanalysis
                                                ? 'icon-shrink2'
                                                : 'icon-enlarge2'
                                        }
                                    />
                                </button>
                            </div>
                        </div>
                        <div
                            className={`content-analysis-under-header ${
                                this.state.showanalysis ? 'show' : ''
                            }`}
                        >
                            <div className="content-analysis-body">
                                {this.state.loading &&
                                    (!this.state.data || this.state.data.length === 0) && (
                                        <Loading padding={10} />
                                    )}
                                {data &&
                                    showedValue?.map((item) => (
                                        <div className="content-analysis-item" key={item.id}>
                                            <div
                                                className={`content-analysis-item-header ${
                                                    item.id === this.state.activeTab
                                                        ? 'active-item'
                                                        : ''
                                                }`}
                                                onClick={() =>
                                                    item.content && this.onToggleActiveTab(item.id)
                                                }
                                            >
                                                <div className="content-analysis-item-header-left">
                                                    <button className="content-analysis-toggle-btn">
                                                        <i className="icon-fi_chevron-down" />
                                                    </button>
                                                    {this.showTitle(item)}
                                                </div>
                                                <div
                                                    className={`content-analysis-item-header-status ${
                                                        item.content ? 'completed' : 'in-progress'
                                                    }`}
                                                >
                                                    {item.content
                                                        ? t('content_analyze.completed')
                                                        : t('content_analyze.in_progress')}
                                                </div>
                                            </div>
                                            <div
                                                className={`content-analysis-item-body ${
                                                    item.id === this.state.activeTab ? 'show' : ''
                                                }`}
                                            >
                                                {item.content && (
                                                    <Markdown>{item.content}</Markdown>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                            {!!data?.length && (
                                <div className="content-analysis-footer">
                                    <div className="content-analysis-footer-actions">
                                        {showAll && (
                                            <a
                                                href={`/domains/${window.info.id}/opportunities/recommendations/`}
                                            >
                                                {t('content_analyze.view_all')}
                                            </a>
                                        )}
                                    </div>
                                    <Pagination
                                        data={data}
                                        onChangePage={this.onChangePage}
                                        pagination={this.state.pagination}
                                        t={t}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <AnalyzeContentDateModal
                    isOpen={this.state.isOpen}
                    onClose={this.onCloseModal}
                    onSubmit={this.onSubmit}
                />
                <ConfirmationModal
                    message="The selected time period yields a limited dataset for this analysis (20 pages or less). Expanding the time range will allow us to process more information and deliver better analysis."
                    isOpen={this.state.isOpenConfirmationModal}
                    onClose={this.onCloseConfirmationModal}
                    onSubmit={() =>
                        this.onAnalyze({
                            start_date: this.state.start_date,
                            end_date: this.state.end_date,
                        })
                    }
                    buttonName="Continue with current selection"
                />
            </>
        );
    }
}
export default withTranslation()(AnalyzeContent);
